var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntermediateGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9962 8.00369C16.2893 10.2967 16.6256 13.8695 16.6625 15.3336H16.6665V16.7326C17.0608 15.5437 17.6848 14.3222 18.67 13.337C21.6116 10.3954 26.6594 10.6739 26.6594 10.6739C26.6594 10.6739 26.9378 15.7217 23.9962 18.6633C21.7033 20.9562 18.1307 21.2927 16.6665 21.3295V26.6669H15.3332V15.9633C13.6329 15.8396 10.6664 15.3264 8.66995 13.33C5.72833 10.3883 6.00681 5.34055 6.00681 5.34055C6.00681 5.34055 11.0546 5.06207 13.9962 8.00369ZM8.74069 7.60298L8.26929 8.07438L13.9261 13.7312L14.3975 13.2598L8.74069 7.60298ZM23.9255 12.936L24.3969 13.4074L18.7401 19.0643L18.2687 18.5929L23.9255 12.936Z",
    fill: "#A1A5B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediateGrey);
export default __webpack_public_path__ + "static/media/IntermediateGrey.6908ecba1fe577ab5967a2ca0d24a4c7.svg";
export { ForwardRef as ReactComponent };